import { Row } from './types';
import { sumColumns } from '../common';
import { ControlledTableColumns, flexColumn } from 'components/ControlledTable';
import { ClientTitle } from 'components';

export const columns: ControlledTableColumns<Row> = [
  {
    content: 'Agency',
    key: 'enterprise_slug',
    width: 80,
  },
  flexColumn({
    content: 'Client grp.',
    configLabel: 'Client group',
    key: 'client_group_title',
    sortable: true,
  }),
  flexColumn({
    content: 'Client',
    key: 'client_internal_name',
    required: true,
    sortable: true,
    render: ({ client_internal_name, payer_internal_name }) => (
      <ClientTitle
        client={{
          internal_name: client_internal_name,
        }}
        payer={{
          internal_name: payer_internal_name,
        }}
      />
    ),
  }),
  ...sumColumns,
];
